/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const AssignTaskPage = lazyLoad(
  () => import('./index'),
  module => module.AssignTaskPage
);
